import { useEffect } from "react";
import { UsePageTitle } from "./types";

const usePageTitle: UsePageTitle = (title) => {
	useEffect(() => {
		if (title) {
			document.title = title;
		}
	}, [title]);
};
export default usePageTitle;
